export interface Organization {
    id: string;
    name: string;
    createdAt: Date;
    onboardingCompletedAt: Date | null;
}

export enum OrganizationUserRole {
    PRIMARY_ADMIN = "primary_admin",
    ADMIN = "admin",
    MEMBER = "member",
}

export interface OrganizationUserAssignment {
    organizationId: string;
    userId: number;
    role: OrganizationUserRole;
    createdAt: Date;
}
